import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import { useNavigate } from 'react-router-dom'
//
import { CLASSES } from '../../../assets/styles/styles'
import LoadingContainer from '../../../components/common/LoadingContainer'
import DocumentsService from '../../../services/DocumentsService'
import ZoomView from '../../../components/common/ZoomView'
import DocumentCard from '../../../components/common/DocumentCard'

function Documents() {
  const navigate = useNavigate()

  const [loading, setLoading] = React.useState(true)
  const [documents, setDocuments] = React.useState([])
  const [state, setState] = React.useState({
    show_modal: false,
    title: null,
    modal_images: null,
  })

  React.useEffect(() => {
    getDocuments()
  }, [])
  const getDocuments = async () => {
    setLoading(true)
    try {
      const response = await DocumentsService.getDocuments()
      setDocuments(response.documents)
      console.log(response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const handleState = (document) =>
    setState((pv) => ({
      ...pv,
      modal_images: document.file_path,
      title: document.title,
      show_modal: !pv.show_modal,
    }))

  return (
    <LoadingContainer loading={loading}>
      <Container className='py-4'>
        <div style={{ fontSize: 30 }} className='text-success text-center mt-5'>
          ALL LEGAL DOCUMENTS
        </div>
        <Row className={CLASSES.content_center + ' my-5'}>
          {documents.length === 0 && (
            <div
              style={{ fontSize: 20 }}
              className='text-muted text-center mt-5'
            >
              No Documents Found
            </div>
          )}
          {documents.map((document, i) => (
            <Col key={document.id} lg={3} md={4} sm={6} className='mb-3'>
              <DocumentCard
                document={document}
                onClick={() => handleState(document)}
              />
              <div
                onClick={() => handleState(document)}
                className='text-center text-bold pointer my-2'
              >
                {document.title}
              </div>
            </Col>
          ))}
        </Row>
      </Container>
      <ZoomView state={state} handleState={() => handleState({})} />
    </LoadingContainer>
  )
}

export default Documents
